import type { ConfigId } from '@squaredup/ids';
import LoadingSpinner from 'components/LoadingSpinner';
import Modal from 'components/Modal';
import { useSaveAsPluginDependencies } from 'pages/datasources/components/saveAsPlugin/useSaveAsPluginDependencies';
import React from 'react';
import { SaveAsPluginModalContent } from './components/SaveAsPluginModalContent';

type SaveAsPluginModalProps = {
    pluginId: string;
    pluginConfigId?: ConfigId['value'];
    onClose: () => void;
};

export const SaveAsPluginModal: React.FC<SaveAsPluginModalProps> = ({ pluginId, pluginConfigId, onClose }) => {
    const { isLoading: isLoadingDependencies, ...dependencies } = useSaveAsPluginDependencies(pluginId, pluginConfigId);

    if (isLoadingDependencies) {
        return (
            <Modal title='Loading...' close={() => undefined} fullWidth={true} fullHeight={true} headerBorder={true}>
                <div className='flex items-center justify-center h-full'>
                    <LoadingSpinner size={32} />
                </div>
            </Modal>
        );
    }

    return <SaveAsPluginModalContent dependencies={dependencies} onClose={onClose} pluginId={pluginId} />;
};
